var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-box"},[_c('div',{staticClass:"top-line"},[_vm._v(" "+_vm._s(_vm.format(_vm.date.month))+" ")]),_c('div',{staticClass:"bottom-line mb-2"},[_vm._v(" "+_vm._s(_vm.date.day)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }